import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest uppercase">Popular Categories</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
            Shop by <br className="md:hidden" />Category
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
            Jump directly to any product category on CSSBuy Sheet. Each category links to curated collections on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-100 rounded-lg hover:bg-primary-50 transition-all cursor-pointer border border-transparent hover:border-primary-200/50"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-background-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-foreground-700 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}